module.exports = __webpack_public_path__ + "static/img/IconAI-lightgray.f7048262.svg";